<template>
  <modal-wrapper
    v-if="contact"
    :shown="true"
    title="Are you sure you want to delete this contact?"
    @close-modal="$emit('close-modal')"
  >
    <table>
      <tr>
        <td>Name:</td>
        <td>
          <b>{{ contact.full_name || `${contact.first_name || ''} ${contact.last_name || ''}` }}</b>
        </td>
      </tr>
      <tr>
        <td>Email:</td>
        <td>
          <b>{{ contact.email }}</b>
        </td>
      </tr>
    </table>

    <button class="btn btn-danger btn-lg modal-action-button danger" :disabled="processing" @click="onDeleteClick">
      Delete
    </button>

    <modal-processing-indicator v-if="processing"></modal-processing-indicator>
  </modal-wrapper>
</template>

<script>
import ModalWrapper from '../modal/ModalWrapper';
import ModalProcessingIndicator from '../modal/ModalProcessingIndicator';
import {handleActionModalResponse} from '../../utility/modal/handleActionModalResponse';
import {deleteContact} from '../../utility/api/contact/deleteContact';

export default {
  name: 'delete-contact-modal',
  components: {ModalWrapper, ModalProcessingIndicator},
  data() {
    return {
      processing: false,
    };
  },
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onDeleteClick() {
      this.processing = true;

      deleteContact(this.contact.id).then(response => {
        if (handleActionModalResponse(response, window.location.pathname + window.location.search)) {
          this.$emit('close-modal');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  color: #ffffff;
  margin: 0 auto;
  width: auto;
}
</style>
